import { Proposal, ProposalStage } from "generated/graphql";
import MapModal from "modules/Mapmodal/MapModal";
import MeasurementsSidebar from "./sidebar/MeasurementsSidebar";
import useStageMeasurements from "hooks/proposals/useStageMeasurements";

type StageMeasurementsModalProps = {
  open: boolean;
  onClose: () => void;
  stage: ProposalStage;
  onSuccess: (proposal: Proposal) => void;
};

export default function StageMeasurementsModal({
  open,
  onClose,
  stage,
  onSuccess,
}: StageMeasurementsModalProps) {
  const measurements = useStageMeasurements({ open, stage, onSuccess, onClose });

  const initialCenter: [number, number] | null =
    stage?.address?.latitude && stage?.address?.longitude
      ? [Number(stage.address.latitude), Number(stage.address.longitude)]
      : null;

  return (
    <MapModal
      open={open}
      onClose={onClose}
      guided={false}
      initialArea={measurements.mapData}
      initialCenter={initialCenter}
      hideLocation={false}
      closeOnSave={false}
      onSave={() => measurements.apply()}
      saveLabel="Update Proposal"
      onFeatureSelect={measurements.handleFeatureSelect}
      onChange={measurements.handleMapChange}
      highlightedFeatureId={measurements.selectedFeatureId}
    >
      <MeasurementsSidebar
        isOpen={measurements.isDrawerOpen}
        onToggle={measurements.toggleDrawer}
        measurements={measurements.measurements}
        selectedFeatureId={measurements.selectedFeatureId}
        onSelectFeature={measurements.selectFeature}
        products={measurements.products}
        groupedAssignments={measurements.groupedAssignments}
        onUpdateProduct={measurements.updateMeasurementProduct}
        onToggleScreenshot={measurements.toggleScreenshot}
        onSave={measurements.save}
        onApply={measurements.apply}
        persisting={measurements.persisting}
        isDirty={measurements.isDirty}
        applyLoading={measurements.applyLoading}
        productsLoading={measurements.productsLoading}
        applyError={measurements.applyError}
        canSave={measurements.canSave}
      />
    </MapModal>
  );
}
